import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-CH") : "");

export default function AdminCancellations() {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/cancellation-feedback").then((r) => setData(r.data)); }, []);
  if (!data) return <p className="text-sm text-text-secondary text-center py-8">{t("admin.loading")}</p>;
  const de = i18n.language?.startsWith("de");
  const label = (c) => t(`cancel.r_${c}`);
  return (
    <div className="space-y-4" data-testid="admin-cancellations">
      <div className="card-c">
        <p className="text-xs uppercase tracking-wider text-text-secondary font-semibold mb-2">{t("admin.top_reasons")}</p>
        {data.counts.length === 0 ? <p className="text-sm text-text-secondary">{t("admin.no_feedback")}</p> : (
          <table className="w-full text-sm" data-testid="admin-cancellations-table">
            <tbody>
              {data.counts.map((c) => (
                <tr key={c.code} className="border-t border-c first:border-0">
                  <td className="py-1.5">{de ? c.label_de : label(c.code)}</td>
                  <td className="py-1.5 text-right font-semibold">{c.n}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <ul className="space-y-2">
        {data.items.map((it, i) => (
          <li key={it.at + i} className="card-c text-sm" data-testid={`admin-cancellation-${i}`}>
            <p className="font-semibold">{label(it.code)} <span className="text-xs text-text-secondary font-normal">· {fmt(it.at)} · {it.plan || "—"} · {it.source === "email" ? t("admin.via_email") : t("admin.via_app")}</span></p>
            <p className="text-xs text-text-secondary">{it.email}</p>
            {it.text && <p className="mt-1 whitespace-pre-wrap">{it.text}</p>}
          </li>
        ))}
      </ul>
    </div>
  );
}
